
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/unacademy-credits-terms",
      function () {
        return require("private-next-pages/unacademy-credits-terms.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/unacademy-credits-terms"])
      });
    }
  